import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fnsr-pending',
  standalone: true,
  templateUrl: './pending.component.html',
})
export class PendingComponent implements OnInit {


  ngOnInit(): void { }

}
